import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type MyNavigatorProps = {
  path: string;
  trigger: any;
};

const MyNavigator = (props: MyNavigatorProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (props.trigger.isToggled) {
      navigate(`${props.path}`);
      props.trigger.toggle();
    }
  }, [props.trigger.isToggled]);

  return <></>;
};
export default MyNavigator;
